import axios from 'axios'
import { filterObject } from "~~/helpers/objects"
import { queryString } from '~~/helpers/url'

export default defineNuxtPlugin(() => {
    const { $startLoading, $stopLoading, $flash } = useNuxtApp()
    const config = useRuntimeConfig()

    const submit = async(method, uri, body, headers) => {
        const url = config.public.api_url + uri

        $startLoading()

        axios.defaults.withCredentials = true
        axios.defaults.headers.common['Accept'] = 'application/json'
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
        axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

        let response = null

        try {
            const { data } = await axios[method](url, body, { headers })

            response = data
        }
        catch(e) {
            $stopLoading()

            if(e.response && e.response.status === 422) {
                $flash(e.response.data.message || 'Alcuni dati sono errati, riprova', 'danger')

                return { errors: e.response.data.errors }
            }
            else {
                $flash('Qualcosa è andato storto', 'danger')
            }
        }

        $stopLoading()

        // console.log(response);

        if(! response) {
            return null
        }

        if(response.message) {
            $flash(response.message, 'success')
        }

        return response.data || response || []
    }

    const getStorageCallParams = async(path, type) => {
        const endpoint = config.public.api_url + 'storage-url'
        const params = queryString({ path, type })

        axios.defaults.withCredentials = true
        axios.defaults.headers.common['Accept'] = 'application/json'
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
        axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

        const { data } = await axios.get(endpoint + '?' + params)

        return data
    }

    return {
        provide: {
            get: async(uri, query, headers) => {
                const url = config.public.api_url + uri

                query = filterObject(query, element => element)

                $startLoading()

                const { data: response } = await useFetch(
                                                url,
                                                {
                                                    query,
                                                    credentials: 'include',
                                                    headers: { 'Accept': 'application/json', ...headers }
                                                },
                                            )

                $stopLoading()

                if(! response.value) {
                    return null
                }

                if(response.value.meta) {
                    return response.value
                }

                return response.value.data || response.value || []
            },

            post: async(uri, body, headers) => {
                return submit('post', uri, body, headers)
            },

            put: async(uri, body, headers) => {
                return submit('put', uri, body, headers)
            },

            delete: async(uri, body, headers) => {
                return submit('delete', uri, body, headers)
            },

            upload: async (path, file) => {
                $startLoading()

                const { url, headers } = await getStorageCallParams(path, file.type)

                try {
                    const response = await axios.put(url, file, {
                        headers: {
                        'Content-Type': file.type
                        },
                        withCredentials: false
                    })
                    const name = new URL(url).pathname.slice(1)
                    const ext = name.split('.').pop()?.toLowerCase()
                    const contentType = (ext === 'pdf') ? 'doc' : 'video'

                    return { upload_output: { name, contentType }, errors: null }
                } catch (e) {
                    console.error("Upload to S3 failed", e)
                    $flash('Errore durante l\'upload su S3', 'danger')
                    return { upload_output: null, errors: e.response?.data || e.message }
                } finally {
                    $stopLoading()
                }
            }
        },
    }
})
